if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      if (FoxTheme.config.mqlTablet) {
        if (!this.openDefault) this.open = false;
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.open = false;
        } else {
          this.open = true;
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}
    var SHOP = Shopify.shop;
    function getCurrencyLocale(currencyCode1) {
      const countryCode = AXT_OBJ.axt_customer_country;

      var currencyCode = currencyCode1;

      var locale = "";
      if (AXT_OBJ.axt_shop == "phiselleritaly.myshopify.com") {
        currencyCode = window.Shopify.currency.active;
      }

      var locale_code = AXT_OBJ.axt_locale_code;
      switch (currencyCode) {
        case "INR":
          locale = locale_code + "-IN";
          break;
        case "USD":
          locale = locale_code + "-US";
          break;
        case "CAD":
          if (locale_code == "en") {
            locale = locale_code + "-CA";
          } else {
            locale = "fr-CA";
          }
          break;
        case "AUD":
          locale = locale_code + "-AU";
          break;
        case "EUR":
          if (
            SHOP == "phiselleritaly.myshopify.com" ||
            SHOP == "boutique-cinzia.myshopify.com"
          ) {
            locale = "it-IT";
          } else if (SHOP == "97cd90-c0.myshopify.com") {
            locale = "it-NL";
          } else if (SHOP == "aa7080-54.myshopify.com") {
            locale = locale_code + "-" + countryCode;
          } else {
            locale = "en-US";
          }
          break;
        case "GBP":
          locale = locale_code + "-GB";
          break;
        case "JPY":
          locale = locale_code + "-JP";
          break;
        case "NZD":
          locale = locale_code + "-NZ";
          break;
        case "HKD":
          locale = locale_code + "-HK";
          break;
        case "SGD":
          locale = locale_code + "-SG";
          break;
        case "DKK":
          locale = locale_code + "-DK";
          break;
        case "kr. DKK":
          locale = locale_code + "-DK";
          break;
        case "CLP":
          locale = locale_code + "-CL";
          break;
        case "AED":
          locale = locale_code + "-" + countryCode;
          break;
        case "SAR":
          if (SHOP == "dermazone-store.myshopify.com") {
            locale = "en-" + countryCode;
          } else {
            locale = locale_code + "-" + countryCode;
          }
          break;
        case "VND":
          locale = locale_code + "-" + countryCode;
          break;
        case "ILS":
          if (SHOP == "yarin-shahaf1.myshopify.com") {
            locale = locale_code;
          } else {
            locale = locale_code + "-" + countryCode;
          }
          break;
        case "CHF":
          locale = locale_code + "-" + countryCode;
          break;
        case "NGN":
          locale = locale_code + "-" + countryCode;
          break;
        case "KRW":
          locale = locale_code + "-" + countryCode;
          break;
        case "NOK":
          locale = locale_code + "-" + countryCode;
          break;
        case "ZAR":
          locale = locale_code + "-" + countryCode;
          break;
        case "BRL":
          locale = locale_code + "-" + countryCode;
          break;
        case "THB":
          locale = locale_code + "-" + countryCode;
          break;
        case "SEK":
          locale = locale_code + "-" + countryCode;
          break;
        case "PHP":
          locale = locale_code + "-" + countryCode;
          break;
        case "COP":
          locale = locale_code + "-" + countryCode;
          break;
        case "PLN":
          locale = "en" + "-" + countryCode;
          break;
        case "UYU":
          locale = "en" + "-" + countryCode;
          break;
        case "CZK":
          locale = locale_code + "-" + countryCode;
          break;
        case "RON":
          locale = locale_code;
          break;
        case "TRY":
          locale = locale_code + "-" + countryCode;
          break;
        case "ARS":
          locale = locale_code + "-" + countryCode;
          break;
      }
      return locale;
    }


    function money_format_custom(price) {
      var locale_code = AXT_OBJ.axt_locale_code;
      const currency_code = AXT_OBJ.axt_currency_code;

      var currency_locale = getCurrencyLocale(currency_code);

      var formatedPrice = price % 1 != 0 ? price : price + ".00";

      var currency = "";
      var price_format = AXT_OBJ.axt_price_format;

      const currency_format = AXT_OBJ.axt_currency_format;
      const currency_code_status = AXT_OBJ.axt_currency_code_status;

      var currency_format2 = currency_format.replace(/"|'/g, "");

      var country = [
        "CAD",
        "INR",
        "USD",
        "AUD",
        "EUR",
        "GBP",
        "JPY",
        "NZD",
        "HKD",
        "SGD",
        "DKK",
        "CLP",
        "AED",
        "VND",
        "ILS",
        "CHF",
        "KRW",
        "SAR",
        "NGN",
        "NOK",
        "ZAR",
        "BRL",
        "THB",
        "SEK",
        "PHP",
        "RON",
        "PLN",
        "UYU",
        "CZK",
        "COP",
        "TRY",
        "ARS",
      ];
      if (country.includes(currency_code)) {
        var findFormate = currency_format2.search("{{amount}}");
        //if find {{amount}} in HTML with currency, admin/settings
        if (findFormate >= 0) {
          var currenyFormat = new Intl.NumberFormat(currency_locale, {
            style: "currency",
            currency: currency_code,
          });
          var staticPrice = currenyFormat.format(0).replace(/\s/g, "");
          staticPrice = price_format.search("0.00") >= 0 ? "$0.00" : "$0,00";

          formatedPrice = currenyFormat.format(formatedPrice);

          if (currency_code == "CAD" && locale_code != "en") {
            if (
              currency_code_status == true ||
              currency_code_status == "true"
            ) {
              currency = price_format.replace(
                staticPrice.substring(1),
                formatedPrice.slice(0, -2),
              );
            } else {
              currency = currency_format2.replace(
                "{{amount}}",
                formatedPrice.slice(0, -2) + " ",
              );
            }
          } else if (currency_code == "DKK") {
            if (
              currency_code_status == true ||
              currency_code_status == "true"
            ) {
              currency = price_format.replace(
                staticPrice.substring(1),
                formatedPrice.slice(0, -4),
              );
            } else {
              currency = currency_format2.replace(
                "{{amount}}",
                formatedPrice.slice(0, -4) + " ",
              );
            }
          } else if (currency_code == "SAR") {
            currency = price_format.replace(
              staticPrice.substring(1),
              formatedPrice.substr(3),
            );
          } else {
            if (
              currency_code_status == true ||
              currency_code_status == "true"
            ) {
              if (currency_code == "AED") {
                if (price_format == "Dhs. 0.00 AED") {
                  currency = price_format.replace(
                    staticPrice.substring(1),
                    formatedPrice.substring(4),
                  );
                } else {
                  currency = price_format.replace(
                    staticPrice.substring(4),
                    formatedPrice.substring(4),
                  );
                }
              } else if (currency_code == "THB") {
                currency = price_format.replace(
                  staticPrice.substring(1),
                  formatedPrice.substring(1),
                );
                currency = currency.replace(/ HB|THB/g, "").trim();
              } else if (SHOP == "bespokepress.myshopify.com") {
                currency = formatedPrice;
              } else {
                currency = price_format.replace(
                  staticPrice.substring(1),
                  formatedPrice.substring(1),
                );
              }
            } else {
              if (currency_code == "AED") {
                currency = currency_format2.replace(
                  "{{amount}}",
                  formatedPrice.substring(4).trim(),
                );
              } else if (currency_code == "ZAR") {
                currency = price_format.replace(
                  staticPrice.substring(1),
                  formatedPrice.substring(1),
                );
                currency = currency.replace("AR", "").trim();
              } else if (
                (currency_code == "CHF" && SHOP == "0zhxe5-f2.myshopify.com") ||
                SHOP == "d4e983-80.myshopify.com"
              ) {
                currency = currency_format2.replace(
                  "{{amount}}",
                  formatedPrice.replace("CHF", "").trim(),
                );
              } else {
                currency = currency_format2.replace(
                  "{{amount}}",
                  formatedPrice.substring(1).trim(),
                );
              }
            }
          }
        }

        findFormate = currency_format2.search("{{amount_no_decimals}}");
        if (findFormate >= 0) {
          var currenyFormat = new Intl.NumberFormat(currency_locale, {
            style: "currency",
            currency: currency_code,
            minimumFractionDigits: 0,
          });
          var staticPrice = currenyFormat.format(0).replace(/\s/g, "");

          if (
            SHOP == "096fb1-6a.myshopify.com" ||
            SHOP == "teeb-store.myshopify.com"
          ) {
            //formatedPrice = Math.round(formatedPrice);
          } else {
            formatedPrice = Math.round(formatedPrice);
          }
          formatedPrice = currenyFormat.format(formatedPrice);

          //var parts = formatedPrice.split(".");
          //formatedPrice = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

          if (currency_code == "CAD" && locale_code != "en") {
            if (
              currency_code_status == true ||
              currency_code_status == "true"
            ) {
              currency = price_format.replace(
                staticPrice.slice(0, -1),
                formatedPrice.slice(0, -2),
              );
            } else {
              currency = currency_format2.replace(
                "{{amount_no_decimals}}",
                formatedPrice.slice(0, -2) + " ",
              );
            }
          } else if (currency_code == "DKK") {
            if (
              currency_code_status == true ||
              currency_code_status == "true"
            ) {
              currency = price_format.replace(
                staticPrice.slice(0, -1),
                formatedPrice.slice(0, -4),
              );
            } else {
              currency = currency_format2.replace(
                "{{amount_no_decimals}}",
                formatedPrice.slice(0, -4) + " ",
              );
            }
          } else if (
            currency_code == "SEK" &&
            (SHOP == "096fb1-6a.myshopify.com" ||
              SHOP == "zeaqxx-wi.myshopify.com")
          ) {
            if (SHOP == "zeaqxx-wi.myshopify.com") {
              currency = formatedPrice.replace("kr", "SEK");
            } else {
              currency = formatedPrice;
            }
          } else if (currency_code == "RON") {
            if (
              currency_code_status == true ||
              currency_code_status == "true"
            ) {
              currency = price_format.replace(
                staticPrice.slice(0, -1),
                formatedPrice.slice(0, -4),
              );
            } else {
              currency = currency_format2.replace(
                "{{amount_no_decimals}}",
                formatedPrice.slice(0, -4) + " ",
              );
            }
          } else {
            if (
              currency_code_status == true ||
              currency_code_status == "true"
            ) {
              currency = price_format.replace(
                staticPrice.substring(1),
                formatedPrice.substring(1),
              );
            } else if (SHOP == "xfggmr-cz.myshopify.com") {
              const input = currency_format2;
              const output = input.replace(/<\/?span[^>]*>/g, "");
              currency = output
                .replace(
                  "{{amount_no_decimals}}",
                  formatedPrice.substring(0) + " ",
                )
                .replace(/\s+kr\s*kr/, " kr");
            } else {
              currency = currency_format2.replace(
                "{{amount_no_decimals}}",
                formatedPrice.substring(1) + " ",
              );
            }
          }
        }
        if (SHOP == "d524d7-85.myshopify.com") {
          currency_format2 = currency_format2.replace(/<span class=money>/, "");
        }
        findFormate = currency_format2.search(
          "{{amount_with_comma_separator}}",
        );
        if (findFormate >= 0) {
          var currenyFormat = new Intl.NumberFormat(currency_locale, {
            style: "currency",
            currency: currency_code,
          });
          var staticPrice = currenyFormat.format(0);

          if (SHOP == "d524d7-85.myshopify.com") {
            price_format = price_format.replace(/<span class=money>/, "");
          }
          //staticPrice = "$0,00";//staticPrice.replace(/\s/g, "");
          staticPrice = price_format.search("0,00") >= 0 ? "$0,00" : "$0,00";

          if (currency_code == "CAD" && locale_code != "en") {
            formatedPrice = currenyFormat.format(formatedPrice);
            if (
              currency_code_status == true ||
              currency_code_status == "true"
            ) {
              currency = price_format.replace(
                staticPrice.substring(1),
                formatedPrice.slice(0, -2),
              );
            } else {
              currency = currency_format2.replace(
                "{{amount_with_comma_separator}}",
                formatedPrice.slice(0, -2) + " ",
              );
            }
          } else if (currency_code == "DKK") {
            formatedPrice = currenyFormat.format(formatedPrice);
            if (
              currency_code_status == true ||
              currency_code_status == "true"
            ) {
              currency = price_format.replace(
                staticPrice.substring(1),
                formatedPrice.slice(0, -4),
              );
            } else {
              currency = currency_format2.replace(
                "{{amount_with_comma_separator}}",
                formatedPrice.slice(0, -4) + " ",
              );
            }
          } else if (currency_code == "BRL") {
            formatedPrice = currenyFormat.format(formatedPrice);
            currency = currency_format2.replace(
              "{{amount_with_comma_separator}}",
              formatedPrice + " ",
            );

            currency = currency.replace(/R\$\d+/, (match) =>
              match.replace("R$", ""),
            );
          } else if (
            currency_code == "SEK" &&
            SHOP == "zeaqxx-wi.myshopify.com"
          ) {
            currency = currency_format2.replace(
              "{{amount_with_comma_separator}}",
              formatedPrice,
            );

            //currency = currency.replace(/SEK|EUR|PLN/g, "").trim();
          } else {
            formatedPrice = currenyFormat.format(formatedPrice);
            if (currency_code_status && currency_code_status !== "false") {
              if (SHOP == "df91c5-05.myshopify.com") {
                currency = price_format.replace(
                  staticPrice.substring(1),
                  formatedPrice.replace(/\s?kr/, ""),
                );
              } else if (SHOP == "aa7080-54.myshopify.com") {
                currency = currency_format2.replace(
                  "{{amount_with_comma_separator}}",
                  formatedPrice.substring(0, formatedPrice.length - 1) + " ",
                );
              } else {
                currency = price_format.replace(
                  staticPrice.substring(1),
                  formatedPrice.substring(1),
                );
              }
            } else {
              if (
                SHOP == "phiselleritaly.myshopify.com" ||
                SHOP == "boutique-cinzia.myshopify.com"
              ) {
                currency = currency_format2.replace(
                  "{{amount_with_comma_separator}}",
                  formatedPrice.substring(0, formatedPrice.length - 1) + " ",
                );
              } else if (SHOP == "ee0192-2.myshopify.com") {
                currency = currency_format2.replace(
                  "{{amount_with_comma_separator}}",
                  formatedPrice.substring(1) + " ",
                );

                currency = currency.replace(".", ",");
              } else if (SHOP == "97cd90-c0.myshopify.com") {
                let currency1 = currency_format2.replace(
                  "{{amount_with_comma_separator}}",
                  formatedPrice.substring(0) + " ",
                );
                currency = currency1.trim().endsWith("€")
                  ? currency1.trim().slice(0, -1).trim() + " " + currency_code
                  : currency1;
              } else if (SHOP == "franzkraler-com.myshopify.com") {
                let rawNumber = parseFloat(
                  formatedPrice.replace(/[^0-9.]/g, ""),
                );
                let formattedNumber = rawNumber.toLocaleString("de-DE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                });
                currency = currency_format2.replace(
                  "{{amount_with_comma_separator}}",
                  formattedNumber,
                );
              } else if (SHOP == "d524d7-85.myshopify.com") {
                currency = currency_format2.replace(
                  "{{amount_with_comma_separator}}",
                  formatedPrice,
                );

                currency = currency.replace("Kč Kč", "Kč").trim();
                currency = currency.replace("CZK", "").trim();
              } else if (SHOP == "annettenailsro.myshopify.com") {
                currency = currency_format2.replace(
                  "{{amount_with_comma_separator}}",
                  formatedPrice.split(" ")[0],
                );
              } else {
                currency = currency_format2.replace(
                  "{{amount_with_comma_separator}}",
                  formatedPrice.substring(1) + " ",
                );
                if (SHOP == "pinkocom.myshopify.com") {
                  currency = currency.replace(/,/g, "").replace(".", ",");
                }
                if (SHOP == "antoniamilano.myshopify.com") {
                  currency = currency.split(".")[0];
                }
              }
            }
          }
        }

        findFormate = currency_format2.search(
          "{{ amount_with_space_separator }}",
        );
        if (findFormate >= 0) {
          var currenyFormat = new Intl.NumberFormat(currency_locale, {
            style: "currency",
            currency: currency_code,
          });
          var staticPrice = currenyFormat.format(0);

          //staticPrice = "$0,00";//staticPrice.replace(/\s/g, "");
          staticPrice = price_format.search("0,00") >= 0 ? "$0,00" : "$0,00";

          formatedPrice = currenyFormat.format(formatedPrice);
          if (currency_code_status && currency_code_status !== "false") {
            currency = currency_format2.replace(
              "{{ amount_with_space_separator }}",
              formatedPrice.replace(/Kč|CZK/g, "").trim() + " ",
            );

            if (SHOP == "laboutiquedesjoyaux.myshopify.com") {
              currency = currency_format2.replace(
                "{{ amount_with_space_separator }}",
                formatedPrice.replace("€", "").trim() + " ",
              );
              currency = currency.replace(/,/g, "").replace(".", ",");
            }
          } else {
            currency = currency_format2.replace(
              "{{ amount_with_space_separator }}",
              formatedPrice.substring(1) + " ",
            );
          }
        }

        findFormate = currency_format2.search(
          "{{amount_no_decimals_with_comma_separator}}",
        );
        if (findFormate >= 0) {
          var currenyFormat = new Intl.NumberFormat(currency_locale, {
            style: "currency",
            currency: currency_code,
            minimumFractionDigits: 0,
          });
          var staticPrice = currenyFormat.format(0).replace(/\s/g, "");
          formatedPrice = Math.round(formatedPrice);
          formatedPrice = currenyFormat.format(formatedPrice);

          if (currency_code == "CAD" && locale_code != "en") {
            if (
              currency_code_status == true ||
              currency_code_status == "true"
            ) {
              currency = price_format.replace(
                staticPrice.slice(0, -1),
                formatedPrice.slice(0, -2),
              );
            } else {
              currency = currency_format2.replace(
                "{{amount_no_decimals_with_comma_separator}}",
                formatedPrice.slice(0, -2) + " ",
              );
            }
          } else if (currency_code == "DKK") {
            if (
              currency_code_status == true ||
              currency_code_status == "true"
            ) {
              currency = price_format.replace(
                staticPrice.slice(0, -3),
                formatedPrice.slice(0, -4),
              );
            } else {
              currency = currency_format2.replace(
                "{{amount_no_decimals_with_comma_separator}}",
                formatedPrice.slice(0, -4) + " ",
              );
            }
          } else {
            if (
              currency_code_status == true ||
              currency_code_status == "true"
            ) {
              currency = price_format.replace(
                staticPrice.substring(1),
                formatedPrice.substring(1),
              );
            } else {
              currency = currency_format2.replace(
                "{{amount_no_decimals_with_comma_separator}}",
                formatedPrice.substring(1) + " ",
              );
            }
          }
        }

        //adddd By harsh
        findFormate = currency_format2.search(
          "{{amount_with_period_separator}}",
        );
        if (findFormate >= 0) {
          var currenyFormat = new Intl.NumberFormat(currency_locale, {
            style: "currency",
            currency: currency_code,
          });
          var staticPrice = currenyFormat.format(0).replace(/\s/g, "");
          formatedPrice = Math.round(formatedPrice);
          formatedPrice = currenyFormat.format(formatedPrice);
          currency = price_format.replace(
            staticPrice.substring(1),
            formatedPrice.slice(0, -2),
          );
          if (SHOP == "98620d-be.myshopify.com") {
            currency = currency.replace("€", "");
          }
        }
        //end by Harsh

        findFormate = currency_format2.search(
          "{{amount_with_apostrophe_separator}}",
        );

        if (findFormate >= 0) {
          var currenyFormat = new Intl.NumberFormat(currency_locale, {
            style: "currency",
            currency: currency_code,
          });
          var staticPrice = currenyFormat.format(0).replace(/\s/g, "");
          staticPrice = price_format.search("0.00") >= 0 ? "$0.00" : "$0,00";

          formatedPrice = currenyFormat.format(formatedPrice);

          if (currency_code == "CAD" && locale_code != "en") {
            if (
              currency_code_status == true ||
              currency_code_status == "true"
            ) {
              currency = price_format.replace(
                staticPrice.substring(1),
                formatedPrice.slice(0, -2),
              );
            } else {
              currency = currency_format2.replace(
                "{{amount_with_apostrophe_separator}}",
                formatedPrice.slice(0, -2) + " ",
              );
            }
          } else if (currency_code == "DKK") {
            if (
              currency_code_status == true ||
              currency_code_status == "true"
            ) {
              currency = price_format.replace(
                staticPrice.substring(1),
                formatedPrice.slice(0, -4),
              );
            } else {
              currency = currency_format2.replace(
                "{{amount_with_apostrophe_separator}}",
                formatedPrice.slice(0, -4) + " ",
              );
            }
          } else {
            if (
              currency_code_status == true ||
              currency_code_status == "true"
            ) {
              currency = price_format.replace(
                staticPrice.substring(1),
                formatedPrice.substring(1),
              );
            } else {
              currency = currency_format2.replace(
                "{{amount_with_apostrophe_separator}}",
                formatedPrice.substring(1) + " ",
              );
            }
          }
        }
      } else {
        var findFormate = currency_format2.search("{{amount}}");
        if (findFormate >= 0) {
          var currenyFormat = new Intl.NumberFormat(currency_locale, {
            style: "currency",
            currency: currency_code,
          });

          formatedPrice = currenyFormat.format(formatedPrice);
          formatedPrice =
            formatedPrice % 1 != 0 ? formatedPrice : formatedPrice + ".00";
          currency = currency_format2.replace(
            "{{amount}}",
            formatedPrice + " ",
          );
        }

        findFormate = currency_format2.search("{{amount_no_decimals}}");
        if (findFormate >= 0) {
          var currenyFormat = new Intl.NumberFormat(currency_locale, {
            style: "currency",
            currency: currency_code,
            minimumFractionDigits: 0,
          });
          formatedPrice = Math.round(formatedPrice);
          formatedPrice = currenyFormat.format(formatedPrice);
          currency = currency_format2.replace(
            "{{amount_no_decimals}}",
            formatedPrice + " ",
          );
        }

        findFormate = currency_format2.search(
          "{{amount_with_comma_separator}}",
        );
        if (findFormate >= 0) {
          var currenyFormat = new Intl.NumberFormat(currency_locale, {
            style: "currency",
            currency: currency_code,
          });
          formatedPrice = currenyFormat.format(formatedPrice);
          currency = currency_format2.replace(
            "{{amount_with_comma_separator}}",
            formatedPrice + " ",
          );
        }

        findFormate = currency_format2.search(
          "{{amount_no_decimals_with_comma_separator}}",
        );
        if (findFormate >= 0) {
          var currenyFormat = new Intl.NumberFormat(currency_locale, {
            style: "currency",
            currency: currency_code,
            minimumFractionDigits: 0,
          });
          formatedPrice = Math.round(formatedPrice);
          formatedPrice = currenyFormat.format(formatedPrice);
          currency = currency_format2.replace(
            "{{amount_no_decimals_with_comma_separator}}",
            formatedPrice + " ",
          );
        }

        findFormate = currency_format2.search(
          "{{amount_with_apostrophe_separator}}",
        );

        if (findFormate >= 0) {
          var currenyFormat = new Intl.NumberFormat(currency_locale, {
            style: "currency",
            currency: currency_code,
          });
          formatedPrice = currenyFormat.format(formatedPrice);
          currency = currency_format2.replace(
            "{{amount_with_apostrophe_separator}}",
            formatedPrice + " ",
          );
        }
      }

      return currency;
    }

  window.wishlistCustomCurrencyFormate= function(price,formate=null){
     var formatedPrice= money_format_custom(price);
     if(formatedPrice ==''){

      var USER_CURRENCY = AXT_OBJ.axt_user_currency;
      var BASE_CURRENCY = AXT_OBJ.axt_base_currency;
      var ACTIVE_CURRENCY = window.Shopify.currency.active;
      var COUNTRY = window.Shopify.country;
      var CUSTOMER_COUNTRY = AXT_OBJ.axt_customer_country;
      var CUSTOMER_TAGS_ARRAY = AXT_OBJ.axt_customer_tags;
      var LOCALE_CODE = window.Shopify.locale;

      var locale_code = AXT_OBJ.axt_locale_code;
      const currency_code = AXT_OBJ.axt_currency_code;

    var currency_locale = getCurrencyLocale(currency_code);

    var formatedPrice = price % 1 != 0 ? price : price + ".00";

    var currency = "";
    var price_format = AXT_OBJ.axt_price_format;

    const currency_format = AXT_OBJ.axt_currency_format;
    const currency_code_status = AXT_OBJ.axt_currency_code_status;

    var currency_format2 = currency_format.replace(/["'\s]/g, "");
    
    var findFormate = currency_format2.search("{{amount}}");
      //if find {{amount}} in HTML with currency, admin/settings
      if (findFormate >= 0) {
        var currenyFormat = new Intl.NumberFormat(currency_locale, {
          style: "currency",
          currency: currency_code,
        });
        var staticPrice = currenyFormat.format(0).replace(/\s/g, "");
        staticPrice = price_format.search("0.00") >= 0 ? "$0.00" : "$0,00";

        formatedPrice = currenyFormat.format(formatedPrice);

        if (currency_code == "CAD" && locale_code != "en") {
          if (currency_code_status == true || currency_code_status == "true") {
            currency = price_format.replace(
              staticPrice.substring(1),
              formatedPrice.slice(0, -2)
            );
          } else {
            currency = currency_format2.replace(
              "{{amount}}",
              formatedPrice.slice(0, -2) + " "
            );
          }
        } else if (currency_code == "DKK") {
          if (currency_code_status == true || currency_code_status == "true") {
            currency = price_format.replace(
              staticPrice.substring(1),
              formatedPrice.slice(0, -4)
            );
          } else {
            currency = currency_format2.replace(
              "{{amount}}",
              formatedPrice.slice(0, -4) + " "
            );
          }
        } else if (currency_code == "SAR") {

          currency = price_format.replace(
            staticPrice.substring(1),
            formatedPrice.substr(3)
          );
        } else {
          if (currency_code_status == true || currency_code_status == "true") {
            if (currency_code == "AED") {
              if (price_format == "Dhs. 0.00 AED") {
                currency = price_format.replace(
                  staticPrice.substring(1),
                  formatedPrice.substring(4)
                );
              } else {
                currency = price_format.replace(
                  staticPrice.substring(4),
                  formatedPrice.substring(4)
                );
              }
            } else if (currency_code == "THB") {
              currency = price_format.replace(
                staticPrice.substring(1),
                formatedPrice.substring(1)
              );
              currency = currency.replace(/ HB|THB/g, "").trim();
            } else if (
              SHOP == "bespokepress.myshopify.com"
            ) {
              currency = formatedPrice;
            } else {
              currency = price_format.replace(
                staticPrice.substring(1),
                formatedPrice.substring(1)
              );
            }
          } else {
            if (currency_code == "AED") {
              currency = currency_format2.replace(
                "{{amount}}",
                formatedPrice.substring(4).trim()
              );
            } else if (currency_code == "ZAR") {
              currency = price_format.replace(
                staticPrice.substring(1),
                formatedPrice.substring(1)
              );
              currency = currency.replace("AR", "").trim();
            } else if (currency_code == "CHF" && SHOP == "0zhxe5-f2.myshopify.com" || SHOP =="d4e983-80.myshopify.com") {
              currency = currency_format2.replace(
                "{{amount}}",
                formatedPrice.replace("CHF", "").trim()
              );
            } else {
              currency = currency_format2.replace(
                "{{amount}}",
                formatedPrice.substring(1).trim()
              );
            }
          }
        }
      }

      return currency;

    }else{
    return formatedPrice;
    }
    
  }